// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PictureFilledSvg from "@fishx/icons-svg/es/asn/PictureFilled";
import FishxIcon from '../components/FishxIcon';

var PictureFilled = function PictureFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureFilledSvg
  }));
};

PictureFilled.displayName = 'PictureFilled';
export default React.forwardRef(PictureFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PictureFilled.js
// module id = 3781
// module chunks = 0